<template>

  <div class="content_support" v-if="proofLoginStatus">

<!--   	<h1 class="entry-title ueberschrift">Supportsystem</h1> -->

  	<div class="woocommerce-error" role="alert" v-if="summaryerror">Fehler. {{ summaryerrordescription }}</div>

  	<div class="activateFormular">
  		<div class="inputfeld">
	  		<label>E-Mail-Adresse</label>
	  		<input v-model="user.username" type="text" id="username" readonly v-if="user.username != ''">
	  		<input v-model="user.username" type="text" id="username" v-else>
	  	</div>

	  	<div class="inputfeld">
	  		<label>Passwort</label>
	  		<input v-model="user.password" type="password" id="password">
	  	</div>

	  	<a href="#" class="btn btn-primary" @click="activateSupportsystem">Freischalten</a>
 	</div>

  </div>

</template>

<script>
import axios from 'axios';

export default {
	data() {
		return {
			apiResponse: '', // initial loading or error messages.
			wpPosts: [], // REST API response data goes here.
			wpData, // global data made available via wp_localize_script.
			user: {
				username: '',
				password: ''
			},
			summaryerror: false,
			summaryerrordescription: ''
		};
	},

	beforeMount() {
		//this.isLoggedIn();
	},

	computed: {
      	proofLoginStatus() {
      		if (this.$store.getters.isLoggedIn == "") {
      			window.location.href = 'https://vali-e.com/konto/';
      		} else {
      			if (this.$store.getters.getZammadID != "" && this.$store.getters.getZammadToken != "") {
      				this.$router.push('/');
      			} else {
      				return true;
      			}
      		}
      	}
	},

	mounted() {
		this.user.username = this.$store.getters.getUserEmail;
	},

	methods: {
		activateSupportsystem() {
			this.$store.commit('setLoadingWorkingScreen')

			//if user.username == ''
			//hier noch die Mail, Firstname und Lastname in Wordpress speichern
			// var data = {
	  //           'nonce': this.wpData.nonce,
	  //           'email': this.user.username
	  //       }
	  //       console.log(data)
			// this.$store.dispatch('addEmail', data)
			// 	.then(resp => {
			// 		console.log(resp)
			// 	}
		 //        .catch(err => {
		 //        	console.log(err)
		 //        })	

			this.summaryerror = false
			var data = {
	            'nonce': this.wpData.nonce,
	            'restURL': this.wpData.rest_url,
	            'password': this.user.password
	        }
			this.$store.dispatch('initializeZammad', data)
		        .then(resp => {
		        	this.$store.commit('setStopLoadingWorkingScreen')
		        	if (resp == "success") {
		        		this.$router.push('/');
		        	} else {
			        	if (resp == "error1") {
			        		this.summaryerror = true
			        		this.summaryerrordescription = "Das Passwort stimmt nicht überein."
			        	} else if (resp == "error2") {
			        		this.summaryerror = true
			        		this.summaryerrordescription = "Fehler beim Anlegen."
			        	} else if (resp == "error3") {
			        		this.summaryerror = true
			        		this.summaryerrordescription = "Der Nutzer ist schon vergeben."
			        	} else {
			        		this.summaryerror = true
			        		this.summaryerrordescription = "Es ist ein unbekannter Fehler aufgetaucht."
			        	}
			        }
		        })
		        .catch(err => {
		        	this.summaryerror = true
		        	this.summaryerrordescription = err
		        	console.log(err)
		        })	

		}

	}
};
</script>

<style scoped>

.activateFormular {
	border: none;
    padding: 20px;
    text-align: left;
    border-radius: 8px;
    background-color: #f4f4f4;
    font-family: 'Roboto', sans-serif;
}

.activateFormular .inputfeld {
   height: 85px;
}

.activateFormular label, .activateFormular input{
   display: block;
}

.activateFormular input:focus {
   border: 1px solid rgb(15, 35, 67);
   outline: none;
}

.activateFormular label {
    line-height: 1.5 !important;
    font-size: 15px;
    font-family: 'Roboto', sans-serif;
    color: #272727;
}

.activateFormular input {
	font-family: 'Roboto', sans-serif;
background-color: #ffffff;
    border: 1px solid #cccccc;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    -webkit-transition: border linear 0.2s, box-shadow linear 0.2s;
    -moz-transition: border linear 0.2s, box-shadow linear 0.2s;
    -o-transition: border linear 0.2s, box-shadow linear 0.2s;
    transition: border linear 0.2s, box-shadow linear 0.2s;
    line-height: 20px;
    padding: 8px;
    width: 100%;
    font-size: 15px;
    color: #000;
    padding-left: 10px;
    padding-right: 10px;
}

.activateFormular input[type="text"]:read-only, .activateFormular input[type="text"]:read-only:focus {
    border: 1px solid #c5c5c5;
    background-color: #f0f0f0;
}

a.btn.btn-primary {
	    background-color: #272727;
    margin-top: 0px;
    color: #fff;
    border: 2px solid #272727;
    background-color: #272727;
    width: auto;
    border: 2px solid #272727;
    padding-left: 23px;
    padding-top: 12px;
    padding-bottom: 12px;
    padding-right: 23px;
    font-family: 'Roboto', sans-serif;
    display: inline-block;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    text-transform: none;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    cursor: pointer;
    border-radius: 20px;
    margin-right: 0px;
}
a.btn.btn-primary:hover { 
    background-color: #a8332e;
    border: 2px solid #a8332e;
    text-decoration: none;
    background-image: none;
    color: #ffffff;
}

</style>



// WEBPACK FOOTER //
// src/components/NoAccess.vue